import Box from '@mui/material/Box';

import { EmptyState } from '@/components/ui/EmptyState';
import { PageHeader } from '@/components/ui/PageHeader';

import { AwaitingInvitationsButton } from './AwaitingInvitationsButton';

const DESCRIPTION =
  'Invite people to join your organization as members and see who has accepted.';

/**
 * The Invitations page before member invitations exist (PB5, P7).
 *
 * A shell on purpose: the header, the disabled "+ New Invitation" and one
 * sentence saying what is coming. No cards and no table, because there is
 * nothing real to put in them until US-052; it reads nothing.
 */
export function InvitationsPage() {
  return (
    <Box data-testid="supporters-invitations-page">
      <PageHeader
        title="Invitations"
        description={DESCRIPTION}
        action={
          <AwaitingInvitationsButton
            label="+ New Invitation"
            testId="supporters-invitations-new"
          />
        }
      />
      <EmptyState
        title="Invitation blasts arrive with member invitations."
        testId="supporters-invitations"
      />
    </Box>
  );
}
